import { AppButton } from './src/AppButton.js';

window.customElements.define('app-button', AppButton);
